import { render, staticRenderFns } from "./CoLink.vue?vue&type=template&id=4c84278a&scoped=true&"
import script from "./CoLink.vue?vue&type=script&lang=ts&"
export * from "./CoLink.vue?vue&type=script&lang=ts&"
import style0 from "./CoLink.vue?vue&type=style&index=0&id=4c84278a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c84278a",
  null
  
)

export default component.exports